import React from 'react';
import Menu from '../menu/Menu';
import RTHeader from './RTHeader';
import RTContentHeader from './RTContentHeader';
import './rtCommon.css';

/**
 * Shared app page shell:
 * - Side Menu + profile icon
 * - Sticky "Hi {name}" header
 * - Optional content title / actions (fixed above scrollable body)
 * - Page body
 *
 * Use menu={false} when the parent already renders Menu (e.g. Home dashboard).
 */
const RTPageLayout = ({
  children,
  title,
  subtitle,
  actions,
  name,
  activePath,
  menu = true,
  mainSection = false,
  contentClassName = '',
}) => {
  const contentHeader =
    title || subtitle || actions ? (
      <RTContentHeader title={title} subtitle={subtitle} actions={actions} />
    ) : null;

  const sectionClass = mainSection ? 'rt-main-section' : 'rt-page-body';
  const body = (
    <div className={sectionClass}>
      {contentHeader}
      <div
        className={`rt-page-scroll${contentHeader ? ' rt-page-scroll--with-header' : ''}`}
      >
        {children}
      </div>
    </div>
  );

  if (!menu) {
    return (
      <>
        <RTHeader name={name} />
        {body}
      </>
    );
  }

  return (
    <div className="rt-layout">
      <Menu className="rt-menu" activePath={activePath} />
      <div className={`rt-main-content ${contentClassName}`.trim()}>
        <RTHeader name={name} />
        {body}
      </div>
    </div>
  );
};

export default RTPageLayout;
